import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'

const service = new ApolloClientService()

export default class CallbackService {
  addCallback = (patientid, request) => {
    return new Promise((resolve, reject) => {
      service
        .addCallback(patientid, request)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }

  getMessages = (filter) => {
    return
    return new Promise((resolve, reject) => {
      service
        .getCallbackRequests(filter)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            let metadata = JSON.parse(JSON.stringify(filter))
            metadata.pagination.total = data.total
            resolve({
              metadata,
              requests: data.requests,
            })
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  deleteMessage = (ids) => {
    return new Promise((resolve, reject) => {
      service
        .deleteCallbackRequest(ids)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err)
        })
    })
  }
}
